import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/HomepageS8.css";

export default function HomepageS8() {
  const frameworkAreas = [
    "Executive accountability",
    "Occupational health and safety",
    "Psychological health and safety",
    "Organizational strategy",
    "Implementation",
    "Measurement",
    "Continual improvement",
  ];

  return (
    // HOMEPAGE SECTION 8
    <section
      id="homepage-section-eight"
      className="homepage-s8"
      aria-labelledby="homepage-s8-title"
    >
      <div className="homepage-s8-background" aria-hidden="true">
        <span className="homepage-s8-glow homepage-s8-glow-left"></span>
        <span className="homepage-s8-glow homepage-s8-glow-right"></span>
      </div>

      <div className="homepage-s8-container">
        <div className="homepage-s8-content">
          <p className="homepage-s8-kicker">
            Developing Governance Framework
          </p>

          <div className="homepage-s8-status">
            <span
              className="homepage-s8-status-dot"
              aria-hidden="true"
            ></span>

            <span>Current Status: In Validation</span>
          </div>

          <h2 id="homepage-s8-title" className="homepage-s8-title">
            PRIME360™
            <span>
              Integrated Safety, Health and Wellbeing Governance
            </span>
          </h2>

          <p className="homepage-s8-description">
            PRIME360™ is a developing, governance-driven framework intended to
            connect executive accountability, occupational and psychological
            health and safety, organizational strategy, implementation,
            measurement, and continual improvement.
          </p>

          <p className="homepage-s8-description homepage-s8-description-secondary">
            It is one important GESI differentiator within a broader portfolio
            of governance, advisory, research, learning, technology, and
            collaboration capabilities.
          </p>

          <NavLink
            to="/prime360"
            className="homepage-s8-button"
          >
            <span>Explore PRIME360™</span>

            <span
              className="homepage-s8-button-arrow"
              aria-hidden="true"
            >
              ↗
            </span>
          </NavLink>

          <p className="homepage-s8-note">
            PRIME360™ is currently in validation. It is not presented as a
            completed standard or certification scheme.
          </p>
        </div>

        <div className="homepage-s8-visual">
          <div className="homepage-s8-framework">
            <div className="homepage-s8-framework-header">
              <div>
                <p>Framework overview</p>
                <h3>Connected governance</h3>
              </div>

              <span className="homepage-s8-framework-mark">
                P360
              </span>
            </div>

            <div className="homepage-s8-framework-core">
              <div className="homepage-s8-core-ring homepage-s8-ring-outer">
                <div className="homepage-s8-core-ring homepage-s8-ring-middle">
                  <div className="homepage-s8-core">
                    <span>PRIME</span>
                    <strong>360™</strong>
                    <small>In Validation</small>
                  </div>
                </div>
              </div>
            </div>

            <div className="homepage-s8-framework-list">
              {frameworkAreas.map((area, index) => (
                <div
                  className="homepage-s8-framework-item"
                  key={area}
                >
                  <span className="homepage-s8-framework-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <p>{area}</p>
                </div>
              ))}
            </div>

            <div className="homepage-s8-framework-footer">
              <span>Governance driven</span>
              <span>Evidence informed</span>
              <span>Continual improvement</span>
            </div>
          </div>

          <span
            className="homepage-s8-orbit homepage-s8-orbit-one"
            aria-hidden="true"
          ></span>

          <span
            className="homepage-s8-orbit homepage-s8-orbit-two"
            aria-hidden="true"
          ></span>
        </div>
      </div>
    </section>
  );
}